
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function ApplyHeroSection() {
  const { t } = useTranslation();

  const scrollToForm = () => {
    const formElement = document.getElementById('apply-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 bg-black/20"></div>
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url('/resources/apply-hero-bg.jpg')`
        }}
      ></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            {t('apply_title')}
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto mb-8 leading-relaxed">
            {t('apply_subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <div className="flex items-center text-white/90">
              <i className="ri-check-circle-fill text-green-400 text-xl mr-2"></i>
              <span>{t('apply_income')}</span>
            </div>
            <div className="flex items-center text-white/90">
              <i className="ri-check-circle-fill text-green-400 text-xl mr-2"></i>
              <span>{t('apply_brands')}</span>
            </div>
            <div className="flex items-center text-white/90">
              <i className="ri-check-circle-fill text-green-400 text-xl mr-2"></i>
              <span>{t('apply_support')}</span>
            </div>
          </div>
          
          <Button 
            size="lg" 
            onClick={scrollToForm}
            className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-black font-semibold px-8 py-4 text-lg shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            <i className="ri-rocket-line mr-2"></i>
            {t('apply_now')}
          </Button>
        </div>
      </div>
    </section>
  );
}
